import { Download, Calendar, Clock, Home, Heart, ShieldCheck, Sparkles } from "lucide-react";
 
export default function LeavePolicy() {
  const policies = [
    {
      title: "Casual Leaves",
      icon: <Calendar className="w-5 h-5" />,
      color: "from-blue-500 to-cyan-400",
      points: [
        "12 annual credits provided.",
        "Requires 24h advance approval.",
        "Prorated for new joiners."
      ]
    },
    {
      title: "Short Leaves",
      icon: <Clock className="w-5 h-5" />,
      color: "from-purple-500 to-pink-400",
      points: [
        "2 credits per month.",
        "Max 2 hours per session.",
        "Use it or lose it monthly."
      ]
    },
    {
      title: "Work From Home",
      icon: <Home className="w-5 h-5" />,
      color: "from-green-500 to-emerald-400",
      points: [
        "1 day per month allowance.",
        "Prior manager okay needed.",
        "High-speed internet mandatory."
      ]
    },
    {
      title: "Marriage Leave",
      icon: <Heart className="w-5 h-5" />,
      color: "from-red-500 to-orange-400",
      points: [
        "7 consecutive days off.",
        "One-time life event claim.",
        "Supporting docs required."
      ]
    }
  ];
 
  return (
    <div className="max-w-8xl mx-auto md:mt-20 md:mb-20">
      <div className="
        relative overflow-hidden
        rounded-[20px] p-10 md:p-12
        bg-gradient-to-br from-[#1e174a] to-[#0f0c29]/95
        backdrop-blur-2xl text-white
        border border-white/10
        shadow-[0_40px_100px_-20px_rgba(0,0,0,0.7)]
      ">
        {/* Background Accents */}
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-purple-600/20 blur-[100px] rounded-full pointer-events-none" />
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-blue-600/20 blur-[100px] rounded-full pointer-events-none" />
 
        <div className="relative z-10">
          {/* Header */}
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6 mb-12">
            <div className="flex items-center gap-2">
              <div className="p-3.5 mt-[-8px] md:mt-0 rounded-2xl bg-gradient-to-br from-indigo-500 to-blue-600 shadow-lg shadow-indigo-500/20 ml-[-20px]">
                <ShieldCheck className="w-8 h-8 text-white" />
              </div>
              <div>
                <h1 className="text-3xl font-semibold text-white flex items-center gap-1 md:gap-3 whitespace-nowrap">
                  Leave Policy
                  {/* <span className="text-xs font-black bg-white/10 px-3 py-1 rounded-full text-blue-400 uppercase tracking-[2px]">2026</span> */}
                </h1>
                <p className="text-white/50 text-sm font-medium">Standard operating procedures for time-off requests</p>
              </div>
            </div>
 
            <a
              href="/Leave policy (2026) 1.pdf"
              download
              className="
                group flex items-center gap-3
                px-6 py-3 rounded-lg
                bg-gradient-to-r from-blue-600 to-indigo-700
                hover:from-blue-500 hover:to-indigo-600
                transition-all duration-300 shadow-xl shadow-blue-900/40
                text-sm font-bold tracking-wider
              "
            >
              <Download className="w-4 h-4 group-hover:animate-bounce" />
              DOWNLOAD PDF
            </a>
          </div>
 
          {/* Policy Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {policies.map((p, i) => (
              <div
                key={i}
                className="
                  group relative overflow-hidden p-8 rounded-[32px]
                  bg-white/5 border border-white/10 backdrop-blur-xl
                  transition-all duration-500 hover:bg-white/[0.08] hover:border-white/20
                "
              >
                <div className={`absolute top-0 right-0 w-24 h-24 bg-gradient-to-br ${p.color} opacity-0 group-hover:opacity-10 blur-2xl transition-all duration-500`} />
               
                <div className="flex items-center gap-4 mb-6">
                  <div className={`p-3 rounded-xl bg-gradient-to-br ${p.color} shadow-lg shadow-black/20 text-white transform transition duration-500 group-hover:rotate-12`}>
                    {p.icon}
                  </div>
                  <h3 className="text-xl font-semibold text-white group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-white group-hover:to-white/60">
                    {p.title}
                  </h3>
                </div>
 
                <div className="space-y-4">
                  {p.points.map((pt, idx) => (
                    <div key={idx} className="flex items-start gap-3">
                      <div className="mt-1.5 w-1.5 h-1.5 rounded-full bg-blue-500/50 group-hover:bg-blue-400 group-hover:scale-125 transition-all" />
                      <p className="text-[14px] text-white/70 font-medium leading-relaxed group-hover:text-white/90 transition-all">
                        {pt}
                      </p>
                    </div>
                  ))}
                </div>
 
                <div className="mt-8 pt-6 border-t border-white/5 flex items-center gap-2 opacity-30 group-hover:opacity-100 transition-all">
                  <Sparkles className="w-3 h-3 text-yellow-400" />
                  <span className="text-[9px] font-black uppercase tracking-widest text-white/60">Updated Jan 2026</span>
                </div>
              </div>
            ))}
          </div>
 
          {/* Footer Note */}
          <div className="mt-12 p-6 rounded-3xl bg-blue-500/5 border border-blue-500/10 flex items-center gap-4">
            <div className="p-2 rounded-full bg-blue-500/20">
              <Clock className="w-4 h-4 text-blue-400" />
            </div>
            <p className="text-xs text-blue-300 font-medium leading-relaxed">
              <strong>Note:</strong> All leave requests are subject to approval by the direct supervisor. Excessive unplanned absenteeism may lead to disciplinary action as per the HR handbook.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
 
 



// import { Download, Calendar, Clock, Home, Heart } from "lucide-react";

// export default function LeavePolicy() {
//   const policies = [
//     {
//       title: "Casual Leaves",
//       icon: <Calendar size={22} />,
//       points: [
//         "12 casual leaves per year.",
//         "Approval required in advance."
//       ]
//     },
//     {
//       title: "Short Leaves",
//       icon: <Clock size={22} />,
//       points: [
//         "2 short leaves per month.",
//         "Not carried forward."
//       ]
//     },
//     {
//       title: "Work From Home",
//       icon: <Home size={22} />,
//       points: [
//         "Max 1 day per month.",
//         "Manager approval required."
//       ]
//     },
//     {
//       title: "Marriage Leave",
//       icon: <Heart size={22} />,
//       points: [
//         "7 days for employee’s own marriage.",
//         "Proof required."
//       ]
//     }
//   ];

//   return (
//     <div className="
//       min-h-screen
//       flex justify-center items-start
//        md:mt-20    p-6 md:p-10
//       bg-gradient-to-br
//       from-[#1b1040]
//       via-[#2d1c6a]
//       to-[#12082f]
//       text-white rounded-3xl
//     ">
//       <div className="
//         w-full max-w-5xl
//         rounded-3xl md:mt-[14px] mt-[-4px]
//         p-6 md:p-10
//         bg-white/10
//         backdrop-blur-xl
//         border border-white/20
//         shadow-[0_20px_60px_rgba(0,0,0,0.5)]
//       ">
//         {/* Header */}
//         <div className="flex flex-col md:flex-row justify-between items-center mb-8">
//           <h2 className="font-bold text-2xl md:text-3xl whites">
//             Leave Policy · 2026
//           </h2>

//           <a
//             href="/Leave policy (2026) 1.pdf"
//             download
//             className="
//               flex items-center gap-2
//               px-2.5 py-2  md:px-4 md:py-2  rounded-lg
//               bg-blue-500/20 text-blue-300
//               hover:bg-blue-500/40
//               transition whitespace-nowrap
//               text-sm md:text-sm md:mt-0 mt-4
//             "
//           >
//             <Download size={16} />
            
//             Download PDF
//           </a>
//         </div>

//         {/* Grid */}
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//           {policies.map((p, i) => (
//             <div
//               key={i}
//               className="
//                 p-5 rounded-xl
//                 bg-white/5
//                 border border-white/10
//                 hover:bg-white/10
//                 transition
//                 shadow-lg
//               "
//             >
//               <div className="flex items-center gap-3 mb-3">
//                 <div className="p-2 rounded-lg bg-blue-500/20 text-blue-300">
//                   {p.icon}
//                 </div>
//                 <h3 className="font-semibold text-lg">
//                   {p.title}
//                 </h3>
//               </div>

//               <ul className="list-disc pl-5 text-white/80 space-y-1 text-sm">
//                 {p.points.map((pt, idx) => (
//                   <li key={idx}>{pt}</li>
//                 ))}
//               </ul>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }
